import { useContext } from 'react';
import { MLNotificationBlockContext } from './MLNotificationBlockContext';

function MLNotificationBlockUtil(){
    const { notificationBlock, setNotificationBlock } = useContext(MLNotificationBlockContext);

    const clearAlerts = () => {
        setNotificationBlock({ type: 'CLEAR_ALL' });
    };
    const clearErrorAlerts = () => {
        setNotificationBlock({ type: 'CLEAR_ERROR' });
    };
    const clearWarningAlerts = () => {
        setNotificationBlock({ type: 'CLEAR_WARN' });
    };
    const clearSpecificWarningAlert = (alertBlock) => {
        if (!alertBlock) return;
        setNotificationBlock({
            type: 'CLEAR_BLOCK',
            block: alertBlock
        });
    };
    const clearInfoAlerts = () => {
        setNotificationBlock({ type: 'CLEAR_INFO' });
    };
    const clearSuccessAlerts = () => {
        setNotificationBlock({ type: 'CLEAR_SUCCESS' });
    };
    const clearBlockAlerts = (block) => {
        setNotificationBlock({ type: 'CLEAR_BLOCK', block: block})
    }
    const clearManyBlockAlerts = (blocks) => {
        setNotificationBlock({ type: 'CLEAR_MANY_BLOCK', blocks: blocks})
    };

    const addErrorAlert = (message, block, onClick, alertHelpTitle, alertHelpMessage, separatedUndoFunc) => {
        setNotificationBlock({ type: 'ADD_ERROR', payload: message, block: block, onClick: onClick, alertHelpTitle, alertHelpMessage, separatedUndoFunc });
        window.scrollTo(0, 0);
    };
    const addWarningAlert = (message, block, onClick, alertHelpTitle, alertHelpMessage, separatedUndoFunc) => {
        setNotificationBlock({ type: 'ADD_WARN', payload: message, block: block, onClick: onClick, alertHelpTitle, alertHelpMessage, separatedUndoFunc });
    };
    const addInfoAlert = (message, block, onClick, alertHelpTitle, alertHelpMessage, separatedUndoFunc) => {
        setNotificationBlock({ type: 'ADD_INFO', payload: message, block: block, onClick: onClick, alertHelpTitle, alertHelpMessage, separatedUndoFunc });
    };
    const addSuccessAlert = (message, block, onClick, alertHelpTitle, alertHelpMessage, separatedUndoFunc) => {
        setNotificationBlock({ type: 'ADD_SUCCESS', payload: message, block: block, onClick: onClick, alertHelpTitle, alertHelpMessage, separatedUndoFunc });
    };
    const clearManyBlockAlertsStartsWith = (block) => {
        setNotificationBlock({ type: 'CLEAR_MANY_BLOCK_STARTS_WITH', block: block})
    }

    const getNumberOfAlerts = (alertName) => {
        if(alertName){
            return notificationBlock.filter((message) => message.block === alertName).length
        }
        return notificationBlock.length
    }

    const getNumberOfAlertsExcludingBlocks = (alertNameArray) => {
        if(alertNameArray){
            return notificationBlock.filter((message) => !alertNameArray.includes(message.block )).length
        }
        
        return notificationBlock.length
    }

    return {
        clearAlerts,
        clearErrorAlerts,
        clearWarningAlerts,
        clearSpecificWarningAlert,
        clearInfoAlerts,
        clearSuccessAlerts,
        clearBlockAlerts,
        addErrorAlert,
        addWarningAlert,
        addInfoAlert,
        addSuccessAlert,
        clearManyBlockAlerts,
        getNumberOfAlerts,
        clearManyBlockAlertsStartsWith,
        getNumberOfAlertsExcludingBlocks
    }
}

export default MLNotificationBlockUtil;